import { ApiError } from '../api/client';

export function Loading({ what }: { what: string }) {
  return (
    <div className="card state" role="status">
      <div className="state__title">Loading {what}…</div>
      {/* Render sleeps on the free tier; a cold start has been measured at over
          90 seconds. Saying so beats a spinner that looks broken. */}
      <p className="muted" style={{ margin: 0 }}>
        If this is the first request in a while, the server may be waking up.
      </p>
    </div>
  );
}

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const api = error instanceof ApiError ? error : null;

  // A lapsed subscription is not an error, it is a bill. 402 exists precisely so
  // this can say so instead of "access denied", which would read as a bug.
  if (api?.isSubscriptionInactive) {
    return (
      <div className="card state">
        <div className="state__title">Your subscription is not active</div>
        <p className="muted">{api.message}</p>
        <p style={{ margin: 0 }}>
          Your data is safe and nothing has been deleted. To restore access, call{' '}
          <a className="shell__phone" href="tel:+917667616304">+91 76676 16304</a>.
        </p>
      </div>
    );
  }

  return (
    <div className="card state" role="alert">
      <div className="state__title">{api?.message ?? 'Something went wrong'}</div>
      {onRetry && <button className="btn" onClick={onRetry} style={{ marginTop: 'var(--s-md)' }}>Try again</button>}
    </div>
  );
}

export function Empty({ title, children }: { title: string; children?: React.ReactNode }) {
  return (
    <div className="card state">
      <div className="state__title">{title}</div>
      {children && <p className="muted" style={{ margin: 0 }}>{children}</p>}
    </div>
  );
}
